import { render } from "./CoverHome.vue?vue&type=template&id=5ba7cadd"
import script from "./CoverHome.vue?vue&type=script&lang=js"
export * from "./CoverHome.vue?vue&type=script&lang=js"

import "./CoverHome.vue?vue&type=style&index=0&id=5ba7cadd&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__